import { createSelector, createSlice } from '@reduxjs/toolkit'

import { AnalyticsActionType } from '../types'
import { Coordinate } from '../../models/activeDrawable'
import IndexableObject from '../../shared/constants/general-enums/indexableObject'
import { RootState } from '../../stores'

export type AnalyticsState = {
    lastLoggedActionIds: Record<AnalyticsActionType, string | null>
    editInitialCoordinates: Coordinate[] | null
    selectionModificationInitialSettings: IndexableObject | null
}

export const initialAnalyticsState: AnalyticsState = {
    lastLoggedActionIds: {
        edit: null,
        create: null,
        selectionModification: null,
    },
    editInitialCoordinates: null,
    selectionModificationInitialSettings: null,
}

function handleSetAnalyticsId(
    state: AnalyticsState,
    action: { payload: { actionType: AnalyticsActionType; id: string } }
) {
    const { actionType, id } = action.payload

    state.lastLoggedActionIds[actionType] = id
}
function handleSetEditInitialCoordinates(state: AnalyticsState, action: { payload: Coordinate[] | null }) {
    state.editInitialCoordinates = action.payload
}
function handleSetSelectionModificationInitialSettings(
    state: AnalyticsState,
    action: { payload: IndexableObject | null }
) {
    state.selectionModificationInitialSettings = action.payload
}

const analyticsSlice = createSlice({
    name: 'analytics',
    initialState: initialAnalyticsState,
    reducers: {
        setAnalyticsId: handleSetAnalyticsId,
        setEditInitialCoordinates: handleSetEditInitialCoordinates,
        setSelectionModificationInitialSettings: handleSetSelectionModificationInitialSettings,
    },
})

export const { setAnalyticsId, setEditInitialCoordinates, setSelectionModificationInitialSettings } =
    analyticsSlice.actions

export const selectAnalyticsActionId = createSelector(
    (state: RootState, analyticsType: AnalyticsActionType) => state.IMUP.analytics.lastLoggedActionIds[analyticsType],
    (actionId) => actionId
)

export default analyticsSlice
